import React, { Suspense, useState } from 'react';
import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { getPageStaticProps } from 'lib/dato-request';
import { Layout } from 'components/Layout';
import ConversionButtons from '../components/ConversionButtons/ConversionButtons';
import { HowItWorks } from 'components/HowItWorks';
import { TPCards } from '@/components/TPCards';
import { useRouter } from 'next/router';
import dynamic from 'next/dynamic';
import ConferenceContents from '@/components/ConferenceContents/ConferenceContents';
import MEDForm from '@/components/MEDForm/MEDForm';
import SummerSchoolSignUp from '@/components/SummerSchoolSignUp/SummerSchoolSignUp';

const ReactPlayer = dynamic(() => import('react-player'), { ssr: false });

const EmailCapturePopup = dynamic(() => import('components/EmailCapturePopup/EmailCapturePopup'), {
    ssr: false
});

const ConnectPage = ({ data }) => {
    const { page } = data;
    const { seo, components } = page;
    const { query: { conference } } = useRouter();
    const [open, setIsOpen] = useState(true);
    return (
        <Layout showClassCodeInput={false}>
            <NextSeo title={seo?.title} description={seo?.description} />
            <Head>
                <meta name='keywords' content={page.keywords} />
            </Head>
            {/* {conference && (<Suspense fallback='Loading...'>
                <EmailCapturePopup
                    open={open}
                    setIsOpen={setIsOpen}
                    conference={conference}
                />
            </Suspense>)} */}
            {/* <MEDForm /> */}
            {/* <ConferenceContents /> */}
            {/* <TPCards /> */}
            {/* <HowItWorks
                heading={components[0].heading}
                subhead={components[0].subhead}
                img={components[0].featuredImage}
                richText={components[0].richText}
                flip={components[0].flipSides}
                ctaButton={false}
                videoLink={null}
            /> */}
            <SummerSchoolSignUp/>
            {/* <div className='text-center px-5'>
                <h2 className='mt-10 text-DavysGrey text-3xl font-black'>***A MUST WATCH VIDEO***</h2>
                <h3 className='mt-10 pb-4 text-5xl font-black bg-clip-text text-transparent bg-gradient-to-r from-MuzPink to-MuzOrange'>
                    Hear what students have to say!
                </h3>
            </div> */}
            <div style={{ maxWidth: '600px', margin: '75px auto', padding: '0 26px' }}>
                <div className='py-10' style={{ position: 'relative', paddingTop: '56.25%' }}>
                    <ReactPlayer
                        style={{
                            position: 'absolute', top: 0, left: 0
                        }}
                        playing={false}
                        url='https://www.youtube.com/watch?v=ZC6pJUUz9GM'
                        width='100%'
                        height='100%'
                        controls={true}
                    />
                </div>
            </div>
            {/* <ConversionButtons /> */}
        </Layout>
    );
};

export async function getStaticProps() {
    return getPageStaticProps('connect');
}

export default ConnectPage;
